import type { TripItineraryItem, TripItemWithoutDay, TripStop, TripDay } from 'tripPlanner/api/types'
import { getStopHotelItems, isBookedHotelItem } from 'tripPlanner/utils/chatItinerary'

type AccommodationEntry = {
  item: TripItineraryItem | TripItemWithoutDay
  dayDate?: string
}

/** Use the same stays and ordering as the hotel drawer, retaining their day context. */
export function getStopAccommodationItems(stop: TripStop | undefined): Array<AccommodationEntry> {
  return getStopHotelItems(stop).map(item => ({
    item,
    dayDate: stop?.days.find(day => day.items.some(dayItem => dayItem === item))?.date,
  }))
}

/** Booked stays keep their per-day occurrence; saved hotel options stay in Accommodation. */
export function getDayTimelineItems(day: TripDay): Array<TripItineraryItem> {
  return day.items.filter(item => {
    if (item.type === 'ACCOMMODATION') return isBookedHotelItem(item)
    return !(item.type === 'FLIGHT' && item.savedItemData?.source === 'chat_flight')
  })
}

/** Hide repeated stay days when the accommodation row contains all itinerary items. */
export function shouldHideAccommodationOnlyDays(stop: TripStop | undefined): boolean {
  if (!stop) return false

  const items = [
    ...stop.days.flatMap(day => day.items),
    ...stop.itemsWithoutDay,
  ]

  return items.length > 0 &&
    items.every(item => item.type === 'ACCOMMODATION') &&
    stop.days.every(day => !day.description.trim() && (!day.title.trim() || day.title === `Day ${day.dayNumber}`))
}
